import { pushToDataLayer } from '@domain-group/fe-helper';

import * as ga from '../../../constants/ga';

const trackReadMore = (): void => {
  pushToDataLayer({
    event: ga.event,
    eventAction: 'Agency Profile',
    eventCategory: ga.category.INTERACTION,
    eventLabel: 'Bio - read more',
  });
};

export default trackReadMore;
